import CardModal from '../CardModal';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import SVGArrow from '@/components/UI/svg/corporatesocialresponsibility/SVGArrow';

export default function C() {
    const { useEffect, useState, useLang, useRouter } = useGlobal();
    const { t } = useLang('corporatesocialresponsibility');
    const { locale } = useRouter();
    const [visible, setVisible] = useState(false);
    const [modalInfo, setModalInfo] = useState({});
    const [active, setActive] = useState(0);

    const new_add_site_25_08_21 = ['eu', 'cn', 'fr', 'de', 'es', 'it', 'jp', 'us', 'ca', 'za', 'au', 'uk', 'mx'];

    const cards: any = [
        ...(new_add_site_25_08_21.includes(locale)
            ? [
                  {
                      title: t('secC_card24_text'),
                      desc: t('secC_card24_desc'),
                      webpImg: 'https://websiteoss.ecoflow.com/upload/image/1754530794146/Tamborine.jpg',
                      img: 'https://websiteoss.ecoflow.com/upload/image/1754530794146/Tamborine.jpg',
                      imgArr: [
                          [
                              'https://websiteoss.ecoflow.com/upload/image/1754530794146/Tamborine.jpg',
                              'https://websiteoss.ecoflow.com/upload/image/1754530794146/Tamborine.jpg',
                          ],
                      ],
                  },
                  {
                      title: t('secC_card22_text'),
                      desc: t('secC_card22_desc'),
                      webpImg: 'https://websiteoss.ecoflow.com/upload/image/1753857763866/1.jpg',
                      img: 'https://websiteoss.ecoflow.com/upload/image/1753857763866/1.jpg',
                      imgArr: [
                          [
                              'https://websiteoss.ecoflow.com/upload/image/1753857763866/1.jpg',
                              'https://websiteoss.ecoflow.com/upload/image/1753857763866/1.jpg',
                          ],
                      ],
                  },
                  {
                      title: t('secC_card23_text'),
                      desc: t('secC_card23_desc'),
                      webpImg: 'https://websiteoss.ecoflow.com/upload/image/1753857763939/2.jpg',
                      img: 'https://websiteoss.ecoflow.com/upload/image/1753857763939/2.jpg',
                      imgArr: [
                          [
                              'https://websiteoss.ecoflow.com/upload/image/1753857763939/2.jpg',
                              'https://websiteoss.ecoflow.com/upload/image/1753857763939/2.jpg',
                          ],
                      ],
                  },
              ]
            : []),
        {
            title: t('secC_card11_text'),
            desc: t('secC_card11_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/common/D1.jpg'),
            img: require('@publicLocal/corporate-social-responsibility/common/D1.jpg'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/common/D1.jpg'), require('@publicLocal/corporate-social-responsibility/common/D1.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/D2.jpg'), require('@publicLocal/corporate-social-responsibility/common/D2.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/D3.jpg'), require('@publicLocal/corporate-social-responsibility/common/D3.jpg')],
            ],
        },
        {
            title: t('secC_card12_text'),
            desc: t('secC_card12_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/common/E1.jpg'),
            img: require('@publicLocal/corporate-social-responsibility/common/E1.jpg'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/common/E1.jpg'), require('@publicLocal/corporate-social-responsibility/common/E1.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/E2.jpg'), require('@publicLocal/corporate-social-responsibility/common/E2.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/E3.jpg'), require('@publicLocal/corporate-social-responsibility/common/E3.jpg')],
            ],
        },
        {
            title: t('secC_card13_text'),
            desc: t('secC_card13_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/common/F1.jpg'),
            img: require('@publicLocal/corporate-social-responsibility/common/F1.jpg'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/common/F1.jpg'), require('@publicLocal/corporate-social-responsibility/common/F1.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/F2.jpg'), require('@publicLocal/corporate-social-responsibility/common/F2.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/F3.jpg'), require('@publicLocal/corporate-social-responsibility/common/F3.jpg')],
            ],
        },
        {
            title: t('secC_card1_text'),
            desc: t('secC_card1_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/h5/3_1_1.jpg'),
            img: require('@publicLocal/corporate-social-responsibility/h5/3_1_1.jpg'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/h5/3_1_1.jpg'), require('@publicLocal/corporate-social-responsibility/h5/3_1_1.jpg')],
                [require('@publicLocal/corporate-social-responsibility/h5/3_1_2.jpg'), require('@publicLocal/corporate-social-responsibility/h5/3_1_2.jpg')],
            ],
        },
        {
            title: t('secC_card2_text'),
            desc: t('secC_card2_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/h5/3_2_1.jpg'),
            img: require('@publicLocal/corporate-social-responsibility/h5/3_2_1.jpg'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/h5/3_2_1.jpg'), require('@publicLocal/corporate-social-responsibility/h5/3_2_1.jpg')],
                [require('@publicLocal/corporate-social-responsibility/h5/3_2_2.jpg'), require('@publicLocal/corporate-social-responsibility/h5/3_2_2.jpg')],
                [require('@publicLocal/corporate-social-responsibility/h5/3_2_3.jpg'), require('@publicLocal/corporate-social-responsibility/h5/3_2_3.jpg')],
            ],
        },
        {
            title: t('secC_card3_text'),
            desc: t('secC_card3_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/h5/3_3_1.webp'),
            img: require('@publicLocal/corporate-social-responsibility/h5/3_3_1.png'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/h5/3_3_1.webp'), require('@publicLocal/corporate-social-responsibility/h5/3_3_1.png')],
                [require('@publicLocal/corporate-social-responsibility/h5/3_3_2.webp'), require('@publicLocal/corporate-social-responsibility/h5/3_3_2.png')],
                [require('@publicLocal/corporate-social-responsibility/h5/3_3_3.webp'), require('@publicLocal/corporate-social-responsibility/h5/3_3_3.png')],
            ],
        },
        {
            title: t('secC_card4_text'),
            desc: t('secC_card4_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/h5/3_4_1.jpg'),
            img: require('@publicLocal/corporate-social-responsibility/h5/3_4_1.jpg'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/h5/3_4_1.jpg'), require('@publicLocal/corporate-social-responsibility/h5/3_4_1.jpg')],
            ],
        },
        {
            title: t('secC_card5_text'),
            desc: t('secC_card5_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/h5/3_5_1.webp'),
            img: require('@publicLocal/corporate-social-responsibility/h5/3_5_1.png'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/h5/3_5_1.webp'), require('@publicLocal/corporate-social-responsibility/h5/3_5_1.png')],
            ],
        },
        {
            title: t('secC_card6_text'),
            desc: t('secC_card6_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/h5/3_6_1.webp'),
            img: require('@publicLocal/corporate-social-responsibility/h5/3_6_1.png'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/h5/3_6_1.webp'), require('@publicLocal/corporate-social-responsibility/h5/3_6_1.png')],
            ],
        },
        {
            title: t('secC_card7_text'),
            desc: t('secC_card7_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/h5/3_7_1.webp'),
            img: require('@publicLocal/corporate-social-responsibility/h5/3_7_1.png'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/h5/3_7_1.webp'), require('@publicLocal/corporate-social-responsibility/h5/3_7_1.png')],
                [require('@publicLocal/corporate-social-responsibility/h5/3_7_2.webp'), require('@publicLocal/corporate-social-responsibility/h5/3_7_2.png')],
            ],
        },
        {
            title: t('secC_card8_text'),
            desc: t('secC_card8_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/h5/3_8_1.webp'),
            img: require('@publicLocal/corporate-social-responsibility/h5/3_8_1.png'),
            imgArr: [['/video/corporate-social-responsibility/h5/6_1.mp4']],
        },
        {
            title: t('secC_card9_text'),
            desc: t.rich('secC_card9_desc', {
                link: (text: string) => (
                    <a className="desc-link" href={'https://www.ecoflow.com/jp/support-for-disaster-prevention'} target={'_blank'} rel="noreferrer">
                        {text}
                    </a>
                ),
            }),
            webpImg: require('@publicLocal/corporate-social-responsibility/h5/3_9_1.webp'),
            img: require('@publicLocal/corporate-social-responsibility/h5/3_9_1.png'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/h5/3_9_1.webp'), require('@publicLocal/corporate-social-responsibility/h5/3_9_1.png')],
            ],
        },
        {
            title: t('secC_card10_text'),
            desc: t('secC_card10_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/h5/3_10_1.webp'),
            img: require('@publicLocal/corporate-social-responsibility/h5/3_10_1.png'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/h5/3_10_1.webp'), require('@publicLocal/corporate-social-responsibility/h5/3_10_1.png')],
                [require('@publicLocal/corporate-social-responsibility/h5/3_10_2.webp'), require('@publicLocal/corporate-social-responsibility/h5/3_10_2.png')],
            ],
        },
    ];

    const clickCard = (card: any) => {
        setVisible(true);
        setModalInfo({
            title: card?.title,
            desc: card?.desc,
            imgs: card?.imgArr,
            webpImg: card?.webpImg,
            img: card?.img,
        });
    };

    let originX = 0,
        startX = 0,
        endsX = 0;
    const onTouchStart = (e: any) => {
        originX = parseFloat(e.currentTarget?.style.left) || 0;
        startX = e.targetTouches[0]?.clientX;
    };

    const onTouchMove = (e: any) => {
        const moveX = e.targetTouches[0]?.clientX;
        const endX = originX + moveX - startX;
        endsX = endX;
        if (endX <= 0 && endX >= window.innerWidth - e.currentTarget.offsetWidth) {
            e.currentTarget.style.left = `${endX}px`;
        }
    };

    const onTouchEnd = (e: any) => {
        const target = document.querySelector('.csr-C .card-lists') as HTMLDivElement;
        // if (endsX <= 0 && endsX >= window.innerWidth - target?.offsetWidth) {
        const cardW = (window.innerWidth / 375) * 320;
        const gapW = (window.innerWidth / 375) * 10;
        const paddingW = (window.innerWidth / 375) * 25;
        const n = Math.floor(Math.abs(endsX - paddingW) / (cardW + gapW));
        const r = (Math.abs(endsX - paddingW) % (cardW + gapW)) / (cardW + gapW);
        setActive(r >= 0.5 ? n + 1 : n);
        // }
    };

    return (
        <div className={`csr-C ${css['csr-C']}`}>
            <div className="secC">
                <div className="content-box">
                    <div className="text-box">
                        <p className="title">{t('secC_title')}</p>
                        <p className="desc">{t('secC_desc')}</p>
                    </div>
                    <div className="card-box">
                        <div className="card-lists" onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd}>
                            {cards?.map((card: any, k: number) => (
                                <div className={`card card${k + 1}`} onClick={() => clickCard(card)} key={k}>
                                    <div className="img">
                                        <NextImage webpSrc={card?.webpImg || card.img} src={card.img} alt={card?.title} aria-label={card?.title} />
                                    </div>
                                    <div className="text-bar">
                                        <p className="text">{card?.title}</p>
                                        <SVGArrow />
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="paginations">
                            {cards?.map((_: any, k: number) => (
                                <span className={`dot ${active === k ? 'active' : ''}`} key={k}></span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            {visible && (
                <CardModal
                    title={modalInfo?.title}
                    desc={modalInfo?.desc}
                    imgs={modalInfo?.imgs}
                    webpImg={modalInfo?.webpImg}
                    img={modalInfo?.img}
                    onClose={() => setVisible(false)}
                />
            )}
        </div>
    );
}
